<template>
  <div class="columns">
    <div class="column">
      <div class="field">
        <label class="is-size-7 is-uppercase">Visit Type</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="visitType" :disabled="loading">
              <option value="all">All</option>
              <option value="warranty">Warranty</option>
              <option value="contract">Contract</option>
              <option value="free">Free</option>
              <option value="chargeable">Chargeable</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="field">
        <label class="is-size-7 is-uppercase">Service Type</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="serviceType" :disabled="loading">
              <option value="all">All</option>
              <option value="installation">Installation</option>
              <option value="breakdown">Breakdown</option>
              <option value="maintenance">Maintenance</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="field">
        <label class="is-size-7 is-uppercase">Status</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="status" :disabled="loading">
              <option value="all">All</option>
              <option value="pending">Pending</option>
              <option value="completed">Completed</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="field">
        <label class="is-size-7 is-uppercase">Sort</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="sort" :disabled="loading">
              <option value="-visitedAt">Newest First</option>
              <option value="visitedAt">Oldest First</option>
              <option value="name">Name A-Z</option>
              <option value="-name">Name Z-A</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serviceType: "all",
      status: "all",
      visitType: "all",
      sort: "-visitedAt"
    };
  },
  computed: {
    loading() {
      let component = this;
      return component.$store.getters["service/loading"];
    }
  },
  methods: {
    refresh() {
      let component = this;
      component.$store.dispatch("service/index");
    }
  },
  watch: {
    serviceType() {
      let component = this;
      component.$store.commit("service/serviceType", component.serviceType);
      component.refresh();
    },
    visitType() {
      let component = this;
      component.$store.commit("service/visitType", component.visitType);
      component.refresh();
    },
    status() {
      let component = this;
      component.$store.commit("service/status", component.status);
      component.refresh();
    },
    sort() {
      let component = this;
      component.$store.commit("service/sort", component.sort);
      component.refresh();
    }
  }
};
</script>
